/* eslint-disable */
import i18n from "@/i18n";

export const verifyCountries = ["AE", "SA", "QA", "BH", "KW", "OM"];
export const othersCategoryId = 99; // Menu -> Buy Now -> Others点击时跳转的link中的categoryId
export const footerAboutItems = [
    {id: 0, name: "Aboutus", path: "/aboutUs"},
    {id: 1, name: "Authenticity", path: "/Authenticity"},
    {id: 2, name: "FAQ", path: "/FAQ"},
    {id: 3, name: "theWorldofFalcons", path: "/blog"},
];
export const footOtherItems = [
    {id: 0, name: "TermsOfService", path: "/information"},
    {id: 1, name: "ContactUs", path: "/ContactUs"},
];
export const headerAboutItem = [
    {id: 0, name: "newAbout", path: "/aboutUs"},
    {id: 1, name: "newAuthenticity", path: "/Authenticity"},
    {id: 2, name: "theWorldofFalcons", path: "/blog"},
];
export const defaultImg =
    "data:image/png;base64,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";
const webINSIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/Instagram.png`;
const webLLIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileLLIcon.svg`;
const webYTBIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileYTBIcon.svg`;
const webFBIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileFaceBookIcon.svg`;
const webTTIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileTTIcon.svg`;
const webTeleIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/wihteTeleIcon.svg`;
const webTwitterIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/twitterIcon.svg`;
export const WhatsAppIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/home/Whatsapp.svg`;

export const mobileGoogleIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileGoogleIcon.png`;
export const mobileAppleIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/mobileAppleIcon.png`;
export const webGoogleIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/webGoogleIcon.png`;
export const webAppleIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonFooter/webAppleIcon.png`;

export const arFalconsLogo = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/Logo update arabic-eng-8.png`;
export const arBlackFalcons = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/Logo update arabic-8.png`;
export const enWhiteFalconsLogo = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/Logo update eng- eng-8.png`;
export const auctionLogo = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/FalconsLogo.svg`;
export const enBlackFalconsLogo = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/Logo update eng-8.png`;
export const blackList = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/blackList.svg`;
export const blackSearchIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/black_search.svg`;
export const whiteSearchIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/white_search.svg`;
export const listIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/listIcon.svg`;

// export const accountIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/AccountIcon.svg`;
export const footerArfalcons = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/enFalconsFooter.png`;
export const footerFalcons = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/landingpage/enFooterFalcons.png`;

export const blackAccountIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/black_account.svg`;
export const whiteAccountIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/white_account.svg`;
export const blackCartIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/black_cart.svg`;
export const whiteCartIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/white_cart.svg`;
export const iconList = [
    {id: 0, src: webINSIcon, path: "https://www.instagram.com/thevaultedcard/"},
    {
        id: 1,
        src: webTTIcon,
        path: "https://www.tiktok.com/@thevaultedcard?_t=8rKblG8Wxcn&_r=1",
    },
    {
        id: 2,
        src: webYTBIcon,
        path: "https://www.youtube.com/channel/UCx3bK83of02qQnb-2EkIfnQ",
    },
];

export const pageRoutes = [
    {id: 1, type: "Handbags", path: "/v2/handbags"},
    {id: 2, type: "Timepieces", path: "/v2/timepieces"},
    {id: 3, type: "Popculturecollectibles", path: "/productDetail"},
    {id: 4, type: "Memorabilia", path: "/v2/memorabilia"},
    {id: 5, type: "SportsCards", path: "/card"},
    {id: 6, type: "Heritagebrands", path: "/productDetail"},
    {id: 7, type: "Cars&collectibles", path: "/productDetail"},
    {id: 8, type: "Toys&comics", path: "/productDetail"},
    {id: 41, type: "Sconcept", path: "/SconceptDetail"},
    {id: 42, type: "Clothing", path: "/SconceptDetail"},
    {id: 56, type: "Automobiles", path: "/v2/cars"},
    {id: 9, type: "CardBox", path: "/cardBox"},
    {id: 59, type: "Shoes", path: "/v2/otherDetails"},
    {id: 60, type: "LeatherGoods", path: "/v2/otherDetails"},
    {id: 61, type: "Readytowear", path: "/v2/readytoWear"},
    {id: 92, type: "Finejewellery", path: "/productDetail"},
];

export const auctionPageRoutes = [
    {id: 1, type: "Handbags", path: "/v2/handbagsauction"},
    {id: 2, type: "Timepieces", path: "/v2/timepiecesauction"},
    {id: 56, type: "Automobiles", path: "/v2/carsauction"},
];

export const categoryPage = [
    {id: 1, type: "handbags"},
    {id: 2, type: "timepieces"},
    {id: 3, type: "popculturecollectibles"},
    {id: 4, type: "memorabilia"},
    {id: 5, type: "sportsCards"},
    {id: 6, type: "heritagebrands"},
    {id: 7, type: "cars&collectibles"},
    {id: 8, type: "toys&comics"},
    {id: 41, type: "sneakers"},
    {id: 42, type: "clothing"},
    {id: 56, type: "automobiles"},
    {id: 9, type: "cardBox"},
    {id: 59, type: "shoes"},
    {id: 60, type: "leatherGoods"},
    {id: 61, type: "readytowear"},
    {id: 91, type: "memorabilia"},
    {id: 92, type: "finejewellery"},
];

export const sellSteps = [
    {
        stepNum: 1,
        stepName: i18n.global.t('sellStep1'),
        stepPercent: '25',
    },
    {
        stepNum: 2,
        stepName: i18n.global.t('sellStep2'),
        stepPercent: '50',
    }, {
        stepNum: 3,
        stepName: i18n.global.t('sellStep3'),
        stepPercent: '75',
    }, {
        stepNum: 4,
        stepName: i18n.global.t('sellStep4'),
        stepPercent: '100',
    },
];

export const sellItemSteps = [
    {
        stepNum: 1,
        stepName: i18n.global.t("PQuotations"),
        stepPercent: "25",
    },
    {
        stepNum: 2,
        stepName: i18n.global.t("Secondaryquotation"),
        stepPercent: "50",
    },
    {
        stepNum: 3,
        stepName: i18n.global.t("finalQuotation"),
        stepPercent: "75",
    },
    {
        stepNum: 4,
        stepName: i18n.global.t("ListingEarn"),
        stepPercent: "100",
    },
];

export const otherData = [
    {id: 0, name: "newArrivals", path: "/category"},
];

export const cartIcon = `${process.env.VUE_APP_CDN_URL}/image/ecommerce/web-2.0/commonHeader/cartIcon.svg`;
